<div class="metabase-dialog">
  <div class="metabase-dialog__icon">
    <mat-icon>info</mat-icon>
  </div>
  <h2 mat-dialog-title>Metabase está seleccionado</h2>
  <mat-dialog-content>
    Recuerda completar el ID de Dashboard en Metabase para que este tablero funcione correctamente.
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button mat-raised-button color="primary" (click)="close()">Entendido</button>
  </mat-dialog-actions>
</div>
